

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { BotProtClient } from '@/utils/botProt';
import { getQueueItHeader } from '@/utils/queue_it';

@Component
export default class BotProt extends Vue {
    widgetId: string | null = null;

    @Ref('botprot-dialog')
    dialog!: HTMLDialogElement;

    @Ref('botprot-widget')
    widgetContainer!: HTMLElement;

    @Prop({ required: true })
    shopId!: string;

    @Prop({ required: true })
    botProtClient!: BotProtClient;

    private showBotProt = false;

    async mounted() {
        const data: Record<string, unknown> = {};

        try {
            await this.waitForQueueItConfig();
        } catch (error) {
            console.warn('BotProt initialization bypassed:', error);
        }

        const queueItHeader = getQueueItHeader();
        if (queueItHeader && queueItHeader.length == 2) {
            switch (queueItHeader[0]) {
                case 'x-queueit-ajaxpageurl':
                    data['queueit-ajaxpageurl'] = queueItHeader[1];
                    break;
                case 'x-queueit-cookies':
                    data['queueit-cookies'] = queueItHeader[1];
                    break;
                default:
                    /* No-op */
                    break;
            }
        }

        this.showBotProt = await this.botProtClient.init(this.shopId, data);

        if (!this.showBotProt) {
            this.$emit('botprot-disabled');
            return false;
        }

        this.botProtClient.onChallengeComplete = (
            _verified: boolean,
            jwt: string | undefined
        ) => {
            this.$emit('verified', { jwt });

            if (this.dialog.open) {
                this.dialog.close();
            }
        };

        this.dialog.showModal();

        this.$nextTick(() => {
            let spinnerImage = this.$whitelabel.resources.spinner;
            if (this.$style.getAppliedTheme() == 'dark')
                spinnerImage = this.$whitelabel.resources.spinnerDark;

            this.botProtClient.render(
                this.widgetContainer,
                '<div><img src="' +
                    spinnerImage +
                    '" style="height: 3rem" alt="Loading"></div>'
            );
        });
    }

    /**
     * Waits for the Queue-it integration to be ready, up to a timeout
     * Needed to avoid a race condition between the Queue-it integration and the botprot init
     * @param timeoutMs
     * @param intervalMs
     */
    async waitForQueueItConfig(
        timeoutMs = 5000,
        intervalMs = 100
    ): Promise<void> {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();

            const intervalId = setInterval(() => {
                if (window.QueueIt?.isIntegrationConfigReady?.()) {
                    clearInterval(intervalId);
                    resolve();
                } else if (Date.now() - startTime > timeoutMs) {
                    clearInterval(intervalId);
                    reject(new Error('QueueIt configuration time out'));
                }
            }, intervalMs);
        });
    }
}
